import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../common/GlobalReportPage';
import { GlobalSchedulesNoMatchesReportView } from './GlobalSchedulesNoMatchesReportView';

type Props = Record<string, never>;

export function GlobalSchedulesNoMatchesReportPage(p: Props) {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.schedulesNoMatches.title',
        defaultMessage: 'Schedules sin matches',
      })}
    >
      <GlobalSchedulesNoMatchesReportView />
    </BaseGlobalReportPage>
  );
}
